import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SchemeHeader } from '../../components/Scheme/SchemeHeader';

export const SchemeHolder: React.FC = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');

  const holders = [
    { id: '1', code: 'DIST-9928', name: 'Krishna Traders', scheme: 'Milk Scheme (SCH-2023-089)', city: 'Vashi/ Mumbai', claimed: 14, freeAvailed: 14, status: 'Active' },
    { id: '2', code: 'DIST-9929', name: 'Metro Supermarket Depot', scheme: 'Milk Scheme (SCH-2023-089)', city: 'Vasai/ Mumbai', claimed: 8, freeAvailed: 8, status: 'Expired' },
    { id: '3', code: 'DIST-9930', name: 'Om Sai Enterprises', scheme: 'Curd Bonanza Scheme (SCH-2023-090)', city: 'Thane', claimed: 25, freeAvailed: 2, status: 'Active' },
    { id: '4', code: 'DIST-9931', name: 'Shree Dairy Distributors', scheme: 'Butter Bulk Offer (SCH-2023-091)', city: 'Andheri/ Mumbai', claimed: 0, freeAvailed: 0, status: 'Upcoming' },
  ];

  const filteredHolders = holders.filter(
    (h) =>
      h.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      h.code.toLowerCase().includes(searchTerm.toLowerCase()) ||
      h.scheme.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="min-h-screen">
      <SchemeHeader
        title="Scheme Holders"
        showBack={true}
        onBackClick={() => navigate('/scheme')}
      />

      <div className="bg-white rounded-2xl p-5 md:p-6 border border-gray-100 shadow-sm">
        <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
          <div>
            <h2 className="text-lg font-bold text-gray-900">Active Scheme Holders & Performance</h2>
            <p className="text-xs text-gray-400">Track distributors benefiting from schemes</p>
          </div>
          <input
            type="text"
            placeholder="Search holder name, code, scheme..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="bg-white border border-gray-300 focus:border-[#B71C1C] outline-none text-xs rounded-xl py-2 px-4 w-72"
          />
        </div>

        <div className="overflow-x-auto border border-gray-100 rounded-xl">
          <table className="w-full text-left text-xs md:text-sm">
            <thead className="bg-[#FFF9E6] text-gray-600 font-semibold">
              <tr>
                <th className="py-3.5 px-4">Distributor Code</th>
                <th className="py-3.5 px-4">Distributor Name</th>
                <th className="py-3.5 px-4">Assigned Scheme</th>
                <th className="py-3.5 px-4">Location</th>
                <th className="py-3.5 px-4 text-center">Units Purchased</th>
                <th className="py-3.5 px-4 text-center">Free Units Claimed</th>
                <th className="py-3.5 px-4 text-center">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {filteredHolders.map((holder) => (
                <tr key={holder.id} className="hover:bg-gray-50 transition-colors">
                  <td className="py-3.5 px-4 font-mono text-gray-500 font-medium">{holder.code}</td>
                  <td className="py-3.5 px-4 font-bold text-gray-800">{holder.name}</td>
                  <td className="py-3.5 px-4 text-[#B71C1C] font-semibold">{holder.scheme}</td>
                  <td className="py-3.5 px-4 text-gray-600">{holder.city}</td>
                  <td className="py-3.5 px-4 text-center font-bold text-gray-700">{holder.claimed}</td>
                  <td className="py-3.5 px-4 text-center">
                    <span className="bg-emerald-50 text-[#16A34A] font-bold px-2.5 py-0.5 rounded border border-emerald-200 text-xs">
                      +{holder.freeAvailed} Free
                    </span>
                  </td>
                  <td className="py-3.5 px-4 text-center text-xs text-[#828282]">
                    {holder.status}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
